// ref: https://github.com/swimlane/ngx-datatable/issues/802
import { DataTablePagerComponent } from "@swimlane/ngx-datatable";

declare module '@swimlane/ngx-datatable/release/components/footer/pager.component' {

}

DataTablePagerComponent.prototype.canPrevious = function(): boolean {
    return this.page > 1;
}

DataTablePagerComponent.prototype.canNext = function(): boolean {
    if (!this.maxSize) this.maxSize = this.size;
    var perPage = Math.max(this.maxSize, this.size);
    var totalPages = Math.trunc(this.count / perPage) + 1;
    return this.page < totalPages;
}

DataTablePagerComponent.prototype.calcPages = function(page?: number): any[] {
    const pages = [];
    let startPage = 1;

    // get total....
    if (!this.maxSize) this.maxSize = this.size;
    var perPage = Math.max(this.maxSize, this.size);
    var totalPages = Math.trunc(this.count / perPage) + 1;

    let endPage = totalPages;
    const maxSize = 5;
    const isMaxSized = maxSize < totalPages;

    page = page || this.page;

    if (isMaxSized) {
        startPage = page - Math.floor(maxSize / 2);
        endPage = page + Math.floor(maxSize / 2);

        if (startPage < 1) {
            startPage = 1;
            endPage = Math.min(startPage + maxSize - 1, totalPages);
        } else if (endPage > totalPages) {
            startPage = Math.max(totalPages - maxSize + 1, 1);
            endPage = totalPages;
        }
    }

    for (let num = startPage; num <= endPage; num++) {
        pages.push({
            number: num,
            text: <string><any>num
        });
    }

    return pages;

}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/shared/table/fix.ts